import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiShield, FiLock } = FiIcons;

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-slate-950 text-slate-400 py-16 px-6 border-t border-slate-900 no-print">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          <div className="col-span-1 lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <SafeIcon icon={FiShield} className="text-blue-500 text-2xl" />
              <div className="flex flex-col">
                <span className="font-bold text-xl text-white tracking-tight">ProtegeTuRed</span>
                <span className="text-[9px] uppercase tracking-widest text-slate-500">by ComplianceBOX</span>
              </div>
            </div>
            <p className="max-w-md text-sm leading-relaxed mb-6">
              Empoderamos a las pequeñas y medianas empresas con herramientas de autodiagnóstico y gestión de cumplimiento para fortalecer su postura de ciberseguridad.
            </p>
            <div className="flex items-center gap-4">
              <button 
                onClick={() => navigate('/admin')}
                className="flex items-center gap-2 text-xs hover:text-blue-400 transition-colors py-2 px-3 bg-slate-900 rounded-md border border-slate-800"
              >
                <SafeIcon icon={FiLock} />
                Acceso Administrador
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Recursos</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="https://media-manager-c.questera.ai/greta-media/c4cd7048ee42a7b0632cdf5aa1fa307c48d20f8ae20304e7af2c62d9e8bb8b361540d414afb44516657958e65ec582f9/documents/YXBwbGljYXRpb24vcGRm/ce44d412c8700e3f13d31873f2f34c28.pdf" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">Guía de Seguridad (PDF)</a></li>
              <li><a href="https://compliancebox.org" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">ComplianceBOX Oficial</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-blue-400 transition-colors">Privacidad</Link></li>
              <li><Link to="/terms" className="hover:text-blue-400 transition-colors">Términos</Link></li>
              <li><a href="mailto:hello@compliancebox.org" className="hover:text-blue-400 transition-colors">Contacto</a></li>
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-slate-900 text-center">
          <p className="text-[11px] text-slate-500 leading-relaxed max-w-4xl mx-auto mb-6 italic">
            Aviso: Este diagnóstico tiene fines educativos e informativos. No constituye una auditoría oficial, certificación, asesoría legal ni garantía de cumplimiento.
          </p>
          <p className="text-xs">
            © {new Date().getFullYear()} ProtegeTuRed by ComplianceBOX. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}